import { useState, useEffect } from "react";
import { AlertCircle } from "lucide-react";
import api from "../../../configs/api";
import PropertyCard from "../../../components/public/userCommon/PropertyCard.jsx";
import { TrackImpression } from "../../../components/public/trackers/TrackImpression.jsx";
import ContactOwnerModal from "../../../components/modals/ContactOwnerModal.jsx";
import useContactModal from "../../../hooks/useContactModal.js";
import ContactForm from "../../../components/public/userCommon/ContactForm.jsx";

const ListingCommercialProperties = () => {
  const [properties, setProperties] = useState([]);

  // SELECTED PROPERTY FOR MODAL
  const [selectedProperty, setSelectedProperty] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { closeModal, isOpen, openModal } = useContactModal();

  useEffect(() => {
    const fetchCommercial = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await api.get("/properties?type=commercial");

        if (res.data.success !== false && res.data.data) {
          setProperties(res.data.data);
        } else {
          setProperties([]);
        }
      } catch (err) {
        setError(err.message || "Failed to load commercial properties");
        setProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCommercial();
  }, []);

  // LOADING STATE
  if (loading) {
    return (
      <div className="bg-gray-50 py-10">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-600 text-lg">
            Loading commercial properties...
          </p>
        </div>
      </div>
    );
  }

  // ERROR STATE
  if (error) {
    return (
      <div className="bg-gray-50 py-10">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <p className="text-red-600 font-semibold mb-2">
              Error Loading Properties
            </p>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  // MAIN UI
  return (
    <div className="bg-gray-50">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">

          {/* MAIN LISTING SECTION */}
          <div className="lg:col-span-3">
            {/* HEADER */}
            <div className="mb-5 sm:mb-6 md:mb-8">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-2 sm:mb-3 text-gray-900">
                Commercial Properties For Sale
              </h2>

              <p className="text-sm sm:text-base text-gray-600">
                {properties.length} Result{properties.length !== 1 ? "s" : ""} |
                Commercial Listings
              </p>
            </div>

            {/* PROPERTY LIST */}
            <div
              className="
                grid 
                grid-cols-1 
                sm:grid-cols-2
                md:grid-cols-1 
                gap-4 
                sm:gap-5 
                md:gap-6
              "
            >
              {properties.length > 0 ? (
                properties.map((property) => (
                  <TrackImpression key={property._id} propertyId={property._id}>
                    <PropertyCard
                      property={property}
                      openModal={openModal}
                      setPropertyData={setSelectedProperty}
                    />
                  </TrackImpression>
                ))
              ) : (
                <div className="col-span-full bg-white rounded-lg shadow-md p-8 text-center">
                  <div className="flex flex-col items-center justify-center py-8">
                    <AlertCircle className="w-16 h-16 text-gray-400 mb-4" />
                    <p className="text-gray-500 text-lg mb-2">
                      No commercial properties found
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="lg:col-span-1">
            <ContactForm />
          </div>
        </div>
      </div>

      {/* CONTACT MODAL */}
      <ContactOwnerModal
        propertyData={selectedProperty}
        isOpen={isOpen}
        onClose={closeModal}
      />
    </div>
  );
};



export default ListingCommercialProperties;
// import { useState, useEffect } from "react";
// import { Heart, Camera, Phone } from "lucide-react";
// import propertiesImg from "../../../assets-user/LandPropertyImg.png";
// import api from "../../../configs/api";
// import { useNavigate } from "react-router-dom";
// import { formatPrice } from "../../../utils/helpers";

// const CommercialProjectCard = ({ project, index }) => {
//   const [liked, setLiked] = useState(false);
//   const navigate = useNavigate();

//   // Format price per sqft
//   const formatPricePerSqft = (pricePerSqft) => {
//     if (!pricePerSqft) return "N/A";
//     return `₹${pricePerSqft.toLocaleString()}/sqft`;
//   };

//   // Format area
//   const formatArea = (area) => {
//     if (!area || !area.value) return "N/A";
//     return `${area.value.toLocaleString()} ${area.unit || "sqft"}`;
//   };

//   // Get image count
//   const getImageCount = () => {
//     if (!project.images || project.images.length === 0) return "No Photos";
//     return `${project.images.length} Photo${
//       project.images.length > 1 ? "s" : ""
//     }`;
//   };

//   // Format date
//   const formatDate = (date) => {
//     if (!date) return "Recently";
//     const now = new Date();
//     const uploadDate = new Date(date);
//     const diffTime = Math.abs(now - uploadDate);
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//     if (diffDays === 0) return "Today";
//     if (diffDays === 1) return "Yesterday";
//     if (diffDays < 30) return `${diffDays} Days Ago`;

//     const diffMonths = Math.floor(diffDays / 30);
//     return `${diffMonths} Month${diffMonths > 1 ? "s" : ""} Ago`;
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col xl:flex-row">
//       {/* Image Section */}
//       <div className="relative xl:w-1/3 flex-shrink-0">
//         <img
//           src={project.images?.[0]?.url || propertiesImg}
//           alt={project.title || "Commercial Property"}
//           className="w-full h-[200px] md:h-[300px] xl:h-[380px] object-cover"
//         />

//         {/* Heart Icon */}
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             setLiked(!liked);
//           }}
//           className="absolute top-3 right-3 bg-white p-2.5 rounded-full shadow-md hover:scale-110 transition-transform"
//         >
//           <Heart
//             className={`w-4 h-4 sm:w-5 sm:h-5 ${
//               liked ? "fill-red-500 text-red-500" : "text-gray-400"
//             }`}
//           />
//         </button>

//         {/* Image Count */}
//         <div className="absolute bottom-3 left-3 bg-black bg-opacity-60 text-white px-3 py-1.5 rounded-full flex items-center gap-1.5 text-xs sm:text-sm font-semibold">
//           <Camera className="w-3 h-3 sm:w-4 sm:h-4" />
//           <span>{getImageCount()}</span>
//         </div>
//       </div>

//       {/* Content Section */}
//       <div className="p-4 sm:p-5 md:p-6 flex-1 flex flex-col">
//         {/* Header: Title and Time */}
//         <div className="mb-3 sm:mb-4">
//           <div className="flex items-start justify-between gap-2 mb-2">
//             <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold text-gray-900 flex-1">
//               {project.title || "Commercial Property for Sale"}
//             </h3>
//             <p className="text-xs sm:text-sm text-gray-500 whitespace-nowrap flex-shrink-0">
//               {formatDate(project.createdAt)}
//             </p>
//           </div>
//           <p className="text-xs sm:text-sm text-gray-600 flex items-center gap-1">
//             📍{" "}
//             {project.location?.address?.formatted || "Location not specified"}
//           </p>
//         </div>

//         {/* Property Details Grid */}
//         <div className="grid grid-cols-3 gap-3 sm:gap-4 md:gap-6 mb-4 sm:mb-5 pb-4 sm:pb-5 border-b border-gray-100">
//           <div>
//             <p className="text-sm sm:text-base md:text-lg font-bold text-gray-900 mb-0.5">
//               {formatPrice(
//                 project.property?.allowedForConstructionDetails?.expectedPrice
//               )}
//             </p>
//             <p className="text-xs sm:text-sm text-gray-600">
//               {formatPricePerSqft(
//                 project.property?.allowedForConstructionDetails?.pricePerSqft
//               )}
//             </p>
//           </div>
//           {(project.property?.allowedForConstructionDetails?.carpetArea
//             ?.value ||
//             project.property?.floors?.totalArea?.value) && (
//             <div>
//               <p className="text-sm sm:text-base md:text-lg font-bold text-gray-900 mb-0.5">
//                 {formatArea(
//                   project.property?.allowedForConstructionDetails?.carpetArea ||
//                     project.property?.floors?.totalArea
//                 )}
//               </p>
//               <p className="text-xs sm:text-sm text-gray-600">Built-up Area</p>
//             </div>
//           )}

//           <div>
//             <p className="text-sm sm:text-base md:text-lg font-bold text-gray-900 mb-0.5">
//               {project.property?.allowedForConstructionDetails?.floor || "N/A"}
//             </p>
//             <p className="text-xs sm:text-sm text-gray-600">
//               Floor{" "}
//               {project.property?.floors?.totalFloors
//                 ? `of ${project.property.floors.totalFloors}`
//                 : ""}
//             </p>
//           </div>
//         </div>

//         {/* Description */}
//         <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-5 line-clamp-2">
//           {project.description ||
//             project.property?.suitableFor ||
//             "Commercial property for sale"}
//         </p>

//         {/* Agent and Action Buttons */}
//         <div className="mt-auto flex flex-col lg:flex-row gap-4 sm:gap-5">
//           {/* Agent Info */}
//           <div className="bg-[#E4F3FF] rounded-tr-3xl px-4 py-3 sm:px-5 flex-1 flex items-center justify-between">
//             <div className="flex items-center gap-2 md:gap-3">
//               <div className="w-10 h-10 md:w-12 md:h-12 bg-gray-900 rounded-full flex items-center justify-center flex-shrink-0">
//                 <span className="text-white font-bold text-base md:text-lg">
//                   {project.listedBy?.name?.[0]?.toUpperCase() || "O"}
//                 </span>
//               </div>
//               <div>
//                 <p className="font-semibold text-gray-900 text-xs md:text-sm">
//                   {project.listedBy?.name || "Owner"}
//                 </p>
//                 <p className="text-gray-500 text-xs">
//                   {project.listedBy?.role || "Owner"}
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex flex-col xl:flex-row gap-2 sm:gap-3">
//             <button
//               onClick={(e) => e.stopPropagation()}
//               className="px-6 py-2 bg-white border-2 border-red-500 text-red-500 rounded-lg font-semibold hover:bg-red-50 transition-colors text-sm sm:text-base flex items-center justify-center gap-2"
//             >
//               <Phone className="w-4 h-4" />
//               <span>View Number</span>
//             </button>
//             <button
//               onClick={() => {
//                 navigate(`${project?._id}`);
//                 window.scrollTo(0, 0);
//               }}
//               className="px-6 py-2 bg-red-500 text-white rounded-lg font-semibold hover:bg-red-600 transition-colors text-sm sm:text-base flex items-center justify-center gap-2"
//             >
//               <Phone className="w-4 h-4" />
//               <span>Contact Owner</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted:", formData);
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-5 sm:p-6 sticky top-4">
//       <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-5">
//         Get in Touch
//       </h3>
//       <div className="space-y-3 sm:space-y-4">
//         <input
//           type="text"
//           placeholder="Your Name"
//           value={formData.name}
//           onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//           className="w-full px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 text-sm sm:text-base"
//         />
//         <input
//           type="email"
//           placeholder="Your Email"
//           value={formData.email}
//           onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//           className="w-full px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 text-sm sm:text-base"
//         />
//         <input
//           type="tel"
//           placeholder="Your Phone"
//           value={formData.phone}
//           onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//           className="w-full px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 text-sm sm:text-base"
//         />
//         <textarea
//           placeholder="Your Message"
//           rows="4"
//           value={formData.message}
//           onChange={(e) =>
//             setFormData({ ...formData, message: e.target.value })
//           }
//           className="w-full px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 text-sm sm:text-base resize-none"
//         />
//         <button
//           onClick={handleSubmit}
//           className="w-full bg-red-500 text-white py-2.5 sm:py-3 rounded-lg font-semibold hover:bg-red-600 transition-colors text-sm sm:text-base"
//         >
//           Send Message
//         </button>
//       </div>
//     </div>
//   );
// };

// const ListingCommercialProperties = () => {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchCommercialProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         console.log("Fetching commercial properties...");
//         const response = await api.get("/properties?type=commercial");

//         console.log("API Response:", response.data);

//         if (response.data.success !== false && response.data.data) {
//           setProjects(response.data.data);
//           console.log(
//             `Successfully loaded ${response.data.data.length} commercial properties`
//           );
//         } else {
//           setProjects([]);
//           console.warn("No commercial properties found");
//         }
//       } catch (error) {
//         console.error("Error fetching commercial properties:", error);
//         setError(error.message || "Failed to load properties");
//         setProjects([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCommercialProperties();
//   }, []);

//   // Loading state
//   if (loading) {
//     return (
//       <div className="bg-gray-50">
//         <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
//           <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
//             <div className="lg:col-span-3">
//               <div className="mb-5 sm:mb-6 md:mb-8">
//                 <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-2 sm:mb-3 text-gray-900">
//                   Commercial Property For Sale
//                 </h2>
//                 <p className="text-sm sm:text-base text-gray-600">
//                   Loading properties...
//                 </p>
//               </div>
//               <div className="flex flex-col gap-4 sm:gap-5 md:gap-6">
//                 {[1, 2, 3].map((i) => (
//                   <div
//                     key={i}
//                     className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse"
//                   >
//                     <div className="flex flex-col md:flex-row">
//                       <div className="md:w-2/5 lg:w-1/3 h-56 md:h-64 bg-gray-200"></div>
//                       <div className="p-4 sm:p-5 md:p-6 flex-1">
//                         <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
//                         <div className="h-4 bg-gray-200 rounded w-1/2 mb-6"></div>
//                         <div className="grid grid-cols-3 gap-4 mb-6">
//                           <div className="h-12 bg-gray-200 rounded"></div>
//                           <div className="h-12 bg-gray-200 rounded"></div>
//                           <div className="h-12 bg-gray-200 rounded"></div>
//                         </div>
//                         <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
//                         <div className="h-4 bg-gray-200 rounded w-2/3"></div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="lg:col-span-1">
//               <ContactForm />
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <div className="bg-gray-50">
//         <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
//           <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
//             <p className="text-red-600 font-semibold mb-2">
//               Error Loading Properties
//             </p>
//             <p className="text-gray-600">{error}</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gray-50">
//       <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
//         <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
//           {/* Main Content */}
//           <div className="lg:col-span-3">
//             {/* Header */}
//             <div className="mb-5 sm:mb-6 md:mb-8">
//               <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-2 sm:mb-3 text-gray-900">
//                 Commercial Property For Sale
//               </h2>
//               <p className="text-sm sm:text-base text-gray-600">
//                 {projects.length} Result{projects.length !== 1 ? "s" : ""} |
//                 Commercial Property for Sale
//               </p>
//             </div>

//             {/* Project Cards */}
//             {projects.length > 0 ? (
//               <div className="flex flex-col gap-4 sm:gap-5 md:gap-6">
//                 {projects.map((project, index) => (
//                   <div key={project._id} className="cursor-pointer">
//                     <CommercialProjectCard project={project} index={index} />
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="bg-white rounded-lg shadow-md p-8 text-center">
//                 <p className="text-gray-600 text-lg">
//                   No commercial properties available at the moment.
//                 </p>
//                 <p className="text-gray-500 text-sm mt-2">
//                   Please check back later.
//                 </p>
//               </div>
//             )}
//           </div>

//           {/* Sidebar Contact Form */}
//           <div className="lg:col-span-1">
//             <ContactForm />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ListingCommercialProperties;
